<!--Header-->
<app-navbar>
    <h2>Cauta Candidati</h2>
</app-navbar>

<!--Empty row-->
<div class="empty-row-40"></div>
<!--Search Candidates-->
<div class="search-area">
    <div class="container">
        <div class="col-md-12 bg-white pt-10 pb-5">
            <div class="row">
                <div class="col-md-4">
                    <!--All Candidates Dropdown-->
                    <select class="form-control form-control-lg">
                        <option>Toti Candidatii</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <!--Categories Dropdown-->
                    <select class="form-control form-control-lg">
                        <option>Categorie</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <!--Location Input-->
                    <div class="location">
                        <div class="form-group">
                            <input type="text" placeholder="Locatie" class="form-control">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Empty row-->
<div class="empty-row-10"></div>
<!--Dropdown section-->
<div class="drop-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-2">
                        <!--Activitate Dropdown-->
                        <select class="form-control form-control-lg">
                            <option>Activitate</option>
                        </select>
                    </div>
                    <div class="col-lg-2">
                        <!--Specializare Dropdown-->
                        <select class="form-control form-control-lg">
                            <option>Specializare</option>
                        </select>
                    </div>
                    <div class="col-lg-2">
                        <!--Aptitudini Dropdown-->
                        <select class="form-control form-control-lg">
                            <option>Aptitudini</option>
                        </select>
                    </div>
                    <div class="col-lg-2">
                        <!--Gen Dropdown-->
                        <select class="form-control form-control-lg">
                            <option>Gen</option>
                        </select>
                    </div>
                    <div class="col-lg-2">
                        <!--Experienta Dropdown-->
                        <select class="form-control form-control-lg">
                            <option>Experienta</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Empty row-->
<div class="empty-row-30"></div>
<!--View Candidates-->
<div class="profile-area">
    <div class="container">
        <div class="col-12 bg-white pt-10 pb-10">
            <div class="row justify-content-around">
                <!--Image Candidates-->
                <div class="col-md-1">
                    <img src="https://via.placeholder.com/100/232359/FFFFFF/?text=THECON">
                </div>
                <div class="col-md-8">
                    <div class="candidate-item">
                        <!--Candidates Infos-->
                        <h1>Vlad Ionut</h1>
                        <div class="job-location d-flex flex-row align-items-center">
                            <i class="icofont-ui-user"></i>
                            <h2>Fermier Agricol</h2>
                            <i class="icofont-location-pin"></i>
                            <h3>Bucuresti,Romania</h3>
                        </div>
                        <div class="registration-date d-flex flex-row">
                            <i class="icofont-ui-user"></i>
                            <p> Inregistrat pe 24 Octombrie 2020</p>

                        </div>
                    </div>
                </div>
                <div class="col text-center pt-10 ml-5">
                    <!--Candidates CV Button-->
                    <a class="green-button">Vezi CV
                        <i class="icofont-file-text"></i></a>
                </div>
            </div>
        </div>
        <!--Empty row-->
        <div class="empty-row-10"></div>
        <div class="col-12 bg-white pt-10 pb-10">
            <div class="row justify-content-around">
                <!--Image Candidates-->
                <div class="col-md-1">
                    <img src="https://via.placeholder.com/100/232359/FFFFFF/?text=THECON">
                </div>
                <div class="col-md-8">
                    <div class="candidate-item">
                        <!--Candidates Infos-->
                        <h1>Vlad Ionut</h1>
                        <div class="job-location d-flex flex-row align-items-center">

                            <i class="icofont-ui-user"></i>
                            <h2>Fermier Agricol</h2>
                            <i class="icofont-location-pin"></i>
                            <h3>Bucuresti,Romania</h3>
                        </div>
                        <div class="registration-date d-flex flex-row">
                            <i class="icofont-ui-user"></i>
                            <p> Inregistrat pe 24 Octombrie 2020</p>
                        </div>
                    </div>
                    <!--Candidates CV Button-->

                </div>
                <div class="col text-center pt-10 ml-5">
                    <!--Candidates CV Button-->
                    <a class="green-button">Vezi CV
                        <i class="icofont-file-text"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
